import {Action} from "redux";
import {CreatePaymentInfoByClientBillingRequest, GetCompanyByClientBillingRequest} from "../request/company_request";
import {
    CreatePaymentInfoByClientBillingResponse,
    GetCompanyByClientBillingResponse
} from "../response/company_response";

export enum ClientBillingActionType {
    REQUEST_GET_COMPANY = "CLIENT_BILLING_REQUEST_GET_COMPANY",
    CALLBACK_GET_COMPANY  = "CLIENT_BILLING_CALLBACK_GET_COMPANY",

//    createPaymentInfo
    REQUEST_CREATE_PAYMENT_INFO = "CLIENT_BILLING_REQUEST_CREATE_PAYMENT_INFO",
    CALLBACK_CREATE_PAYMENT_INFO = "CLIENT_BILLING_CALLBACK_CREATE_PAYMENT_INFO",
}

export interface IRequestGetCompanyAction extends Action {
    type: ClientBillingActionType.REQUEST_GET_COMPANY;
    item: GetCompanyByClientBillingRequest;
}

export interface ICallbackGetCompanyAction extends Action {
    type: ClientBillingActionType.CALLBACK_GET_COMPANY;
    isSuccess: boolean;
    item?: GetCompanyByClientBillingResponse;
}

export interface IRequestCreatePaymentInfoAction extends Action {
    type: ClientBillingActionType.REQUEST_CREATE_PAYMENT_INFO;
    item: CreatePaymentInfoByClientBillingRequest;
}

export interface ICallbackCreatePaymentInfoAction extends Action {
    type: ClientBillingActionType.CALLBACK_CREATE_PAYMENT_INFO;
    isSuccess: boolean;
    item?: CreatePaymentInfoByClientBillingResponse;
}

export type ClientBillingAction =
    IRequestGetCompanyAction |
    ICallbackGetCompanyAction |
    IRequestCreatePaymentInfoAction |
    ICallbackCreatePaymentInfoAction
    ;

export interface IClientBillingActionCreator {
    requestGetCompanyAction(item: GetCompanyByClientBillingRequest): IRequestGetCompanyAction;

    callbackGetCompanyAction(isSuccess: boolean, item?: GetCompanyByClientBillingResponse): ICallbackGetCompanyAction;

    requestCreatePaymentInfoAction(item: CreatePaymentInfoByClientBillingRequest): IRequestCreatePaymentInfoAction;

    callbackCreatePaymentInfoAction(isSuccess: boolean, item?: CreatePaymentInfoByClientBillingResponse): ICallbackCreatePaymentInfoAction;
}

class ActionCreator implements IClientBillingActionCreator {
    public requestGetCompanyAction = (item: GetCompanyByClientBillingRequest): IRequestGetCompanyAction => {
        return {
            type: ClientBillingActionType.REQUEST_GET_COMPANY,
            item,
        };
    };

    public callbackGetCompanyAction = (isSuccess: boolean, item: GetCompanyByClientBillingResponse): ICallbackGetCompanyAction => {
        return {
            type: ClientBillingActionType.CALLBACK_GET_COMPANY,
            isSuccess,
            item,
        };
    };

    public requestCreatePaymentInfoAction = (item: CreatePaymentInfoByClientBillingRequest): IRequestCreatePaymentInfoAction => {
        return {
            type: ClientBillingActionType.REQUEST_CREATE_PAYMENT_INFO,
            item,
        };
    };

    public callbackCreatePaymentInfoAction = (isSuccess: boolean, item: CreatePaymentInfoByClientBillingResponse): ICallbackCreatePaymentInfoAction => {
        return {
            type: ClientBillingActionType.CALLBACK_CREATE_PAYMENT_INFO,
            isSuccess,
            item,
        };
    };
}

export const createClientBillingActionCreator = (): IClientBillingActionCreator => {
    return new ActionCreator();
};



// WEBPACK FOOTER //
// ./src/presentation/action/client_billing_action.ts